import { useState, useEffect } from "react";
import { debounce, result } from "lodash";

import CustomButton from "../components/kits/button/CustomButton";
import useAxios from "../services/useAxios";

import OrderList from "../components/order-list-page";

import "../components/order-list-page/order-list-page-style.scss";
import { NavLink } from "react-router-dom";
import OrderFilter from "../components/order-list-page/OrderFilter";

import { translateToReactSelect } from "../utils/helperFunction";
import Loader from "../utils/Loader";

export default function OrderListPage() {
  // apis
  const { execute: orderListApi } = useAxios("order/get_orders");
  const { execute: getConfigsAPI } = useAxios("api2/get_configs");
  const { execute: getProductsApi } = useAxios("product/get_products");
  const { execute: getCustomerApi } = useAxios("product/get_customers");
  // states
  const [orderListState, setOrderListState] = useState([]);
  const [orderListTotal, setOrderListTotal] = useState(0);
  const [orderListUpdater, setOrderListUpdater] = useState(false);
  const [filterModal, setFilterModal] = useState(false);
  const [filterData, setFilterData] = useState({
    type: "",
    product: "",
    customer: "",
    paid_status: "",
    production_status: "",
    financial_status: "",
    store_status: "",
    order_status: "",
    from_tm: "",
    to_tm: "",
    from_order_tm: "",
    to_order_tm: "",
  });
  const [filterFlag, setFilterFlag] = useState(false);
  const [filterDataValid, setFilterDataValid] = useState({});
  const [loading, setLoading] = useState(false);
  const [productListOption, setProductListOption] = useState([]);
  const [customerListOption, setCustomerListOption] = useState([]);
  const [statusList, setStatusList] = useState({
    detail_order: [],
    production: [],
    financial: [],
    store: [],
  });
  // functions
  const customerListFunc = (txt) => {
    getCustomerApi({
      page: 1,
      count: 100,
      keyword: txt,
    }).then((data) => {
      let customerListTemp = data?.result?.map((v) => {
        if (v.corporate == 1)
          return {
            label: `${v?.company_name} (${v?.firstname} ${v.lastname} - ${v?.mobile})`,
            value: v?.id,
          };
        else
          return {
            label: `${v?.firstname} ${v.lastname} - ${v?.mobile}`,
            value: v?.id,
          };
      });
      setCustomerListOption(customerListTemp ?? []);
    });
  };
  const productListFunc = (txt) => {
    getProductsApi({
      page: 1,
      count: 100,
      title: txt,
    }).then((data) => {
      setProductListOption(
        translateToReactSelect(false, data?.result, "title", true, "id") ?? []
      );
    });
  };
  const customerDebounce = debounce(customerListFunc, 1000);
  const productDebounce = debounce(productListFunc, 1000);
  const changeDataFilter = (
    object,
    type = "nonProductProperties",
    idProperty
  ) => {
    console.log("filterData funct", object, type, idProperty);
    if (type == "productProperties") {
      let tempProductProperties = filterData?.product?.properties;
      tempProductProperties = tempProductProperties?.map((v) => {
        if (v?.product_properties__id == idProperty) {
          return { ...v, ...object };
        } else {
          return v;
        }
      });
      setFilterData((prev) => {
        return {
          ...prev,
          product: { ...prev?.product, properties: tempProductProperties },
        };
      });
    } else {
      setFilterData((prev) => {
        return { ...prev, ...object };
      });
    }
  };
  const orderListFunc = (object, page = 1) => {
    orderListApi({ ...object, page: page, count: 10 }).then((result) => {
      setOrderListState(result?.result ?? []);
      setOrderListTotal(result?.total);
    });
  };
  const filterFunc = (object) => {
    let payloadTemp;
    if (object?.type?.value != undefined && object?.type?.value != "") {
      payloadTemp = { ...payloadTemp, type: object?.type?.value };
    }
    if (object?.customer?.value != undefined && object?.customer?.value != "") {
      payloadTemp = { ...payloadTemp, customer_id: object?.customer?.value };
    }
    if (object?.product?.value != undefined && object?.product?.value != "") {
      payloadTemp = { ...payloadTemp, products_id: object?.product?.value };
    }
    if (
      object?.production_status?.value != undefined &&
      object?.production_status?.value != ""
    ) {
      payloadTemp = {
        ...payloadTemp,
        production_status: object?.production_status?.value,
      };
    }
    if (
      object?.financial_status?.value != undefined &&
      object?.financial_status?.value != ""
    ) {
      payloadTemp = {
        ...payloadTemp,
        financial_status: object?.financial_status?.value,
      };
    }
    if (
      object?.repository_status?.value != undefined &&
      object?.repository_status?.value != ""
    ) {
      payloadTemp = {
        ...payloadTemp,
        repository_status: object?.repository_status?.value,
      };
    }
    if (
      object?.order_details_status?.value != undefined &&
      object?.order_details_status?.value != ""
    ) {
      payloadTemp = {
        ...payloadTemp,
        order_details_status: object?.order_details_status?.value,
      };
    }
    if (
      object?.from_tm?.unix != undefined &&
      object?.to_tm?.unix != undefined
    ) {
      payloadTemp = {
        ...payloadTemp,
        time: `${object?.from_tm?.unix},${object?.to_tm?.unix}`,
      };
    }
    if (
      object?.from_order_tm?.unix != undefined &&
      object?.to_order_tm?.unix != undefined
    ) {
      payloadTemp = {
        ...payloadTemp,
        order_date: `${object?.from_tm?.unix},${object?.to_tm?.unix}`,
      };
    }
    setFilterDataValid(payloadTemp);
    setFilterFlag(true);
    orderListFunc(payloadTemp);
    setFilterModal(false);
  };
  // useEffects
  useEffect(() => {
    setLoading(true);
    async function LoadPage() {
      await orderListFunc();
      await getConfigsAPI().then((result) => {
        setStatusList(result?.order_status ?? []);
      });
      setLoading(false);
    }
    LoadPage();
    customerDebounce("");
    productDebounce("");
  }, [orderListUpdater]);
  return loading ? (
    <Loader />
  ) : (
    <div className="order-list-page-style">
      <div className="d-flex flex-wrap">
        <NavLink to="/new-order/create/2" className="text-decoration-none">
          <CustomButton
            style={{ width: 160 }}
            className="m-1"
            onClick={() => {}}
            color="primary"
          >
            افزودن سفارش فروش
          </CustomButton>
        </NavLink>
        <NavLink to="/new-order/create/1" className="text-decoration-none">
          <CustomButton
            style={{ width: 160 }}
            className="m-1"
            onClick={() => {}}
            color="primary"
          >
            افزودن سفارش خرید
          </CustomButton>
        </NavLink>
        <CustomButton
          style={{ width: 100 }}
          className="m-1 justify-content-center"
          onClick={() => {
            setFilterModal(true);
          }}
          color="info"
        >
          فیلتر
        </CustomButton>
      </div>
      <div className="mt-4">
        <OrderList
          data={orderListState}
          statusList={statusList}
          setOrderListUpdater={setOrderListUpdater}
          orderListTotal={orderListTotal}
          orderListFunc={orderListFunc}
          filterFlag={filterFlag}
          filterDataValid={filterDataValid}
        />
      </div>
      <OrderFilter
        show={filterModal}
        setShow={setFilterModal}
        productDebounce={productDebounce}
        customerDebounce={customerDebounce}
        productListOption={productListOption}
        customerListOption={customerListOption}
        changeDataFilter={changeDataFilter}
        filterData={filterData}
        statusList={statusList}
        filterFunc={filterFunc}
        setFilterFlag={setFilterFlag}
        orderListFunc={orderListFunc}
      />
    </div>
  );
}
